function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m56.352 44.1h-4.152a1 1 0 0 1 0-2h4.152c6.837 0 11.995-4.846 11.995-11.271a11.933 11.933 0 0 0 -10.827-11.937 1 1 0 0 1 -.875-.755 17.516 17.516 0 0 0 -31.761-5.22 1 1 0 0 1 -1.248.376 7.477 7.477 0 0 0 -9.814 9.962 1 1 0 0 1 -.367 1.263 9.53 9.53 0 0 0 5.108 17.582h6.614a1 1 0 0 1 0 2h-6.614a11.529 11.529 0 0 1 -6.877-20.785 9.366 9.366 0 0 1 -.547-3.177 9.489 9.489 0 0 1 9.478-9.479 9.383 9.383 0 0 1 3.039.5 19.517 19.517 0 0 1 34.751 5.828 13.924 13.924 0 0 1 11.94 13.841c0 7.563-6.017 13.272-13.995 13.272z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m29.735 72.834h-4.558a1 1 0 0 1 -1-1v-44.186a1 1 0 0 1 1-1h4.558a1 1 0 0 1 1 1v44.186a1 1 0 0 1 -1 1zm-3.558-2h2.558v-42.186h-2.558z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m47.642 38.959h-17.907a1 1 0 0 1 -1-1v-3.715a1 1 0 0 1 1-1h17.907a1 1 0 0 1 1 1v3.715a1 1 0 0 1 -1 1zm-16.907-2h15.907v-1.715h-15.907z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m47.642 52.6h-17.907a1 1 0 0 1 -1-1v-3.716a1 1 0 0 1 1-1h17.907a1 1 0 0 1 1 1v3.716a1 1 0 0 1 -1 1zm-16.907-2h15.907v-1.716h-15.907z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m47.642 66.238h-17.907a1 1 0 0 1 -1-1v-3.715a1 1 0 0 1 1-1h17.907a1 1 0 0 1 1 1v3.715a1 1 0 0 1 -1 1zm-16.907-2h15.907v-1.715h-15.907z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m52.2 72.834h-4.558a1 1 0 0 1 -1-1v-44.186a1 1 0 0 1 1-1h4.558a1 1 0 0 1 1 1v44.186a1 1 0 0 1 -1 1zm-3.558-2h2.558v-42.186h-2.558z"
});

function Svg018Success(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line_icons",
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "line icons",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg018Success);
export default __webpack_public_path__ + "static/media/018-success.0760905b.svg";
export { ForwardRef as ReactComponent };